module.exports = __webpack_public_path__ + "img/courseOver.869aae25.jpg";